import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PROSPECTS_LABEL } from '@shared/utils';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { TotalShortlistCandidate } from '@app/collections/candidates';
import { ALL_SELECTED } from '@shared';
import { Store } from '@ngrx/store';
import { getInnerRouterPath } from '@app/app.reducer';

const DIRECT_APPLICANTS = 'direct-applicants';

export interface HMStatuses {
  hmStatus: string[];
  statuses: string[];
}

@Component({
  selector: 'mojo-job-assign-collection-header',
  templateUrl: './job-assign-collection-header.component.html',
  styleUrls: ['./job-assign-collection-header.component.scss'],
})
export class JobAssignCollectionHeaderComponent implements OnInit {
  @Input() showSeeAll: boolean;
  @Input() showHeaderOnMobile: boolean;
  @Input() totalElements: number;
  @Input() statuses: string[];
  @Input() hideFilters: boolean;
  @Input() totalElementsOnList: TotalShortlistCandidate;
  @Output() statusesChange = new EventEmitter<HMStatuses>();
  @Output() expandenOutput = new EventEmitter<boolean>();
  isHiringManagerFlow = AppFeatureExtensions.HIRING_MANAGER_FLOW;
  hmStatusesOpcSelected: string[] = [];
  normalStatusesOpcSelected: string[] = [];
  allStatuses: HMStatuses = {
    hmStatus: [],
    statuses: [],
  };

  @Input()
  isExpandible = false;

  @Input()
  expanded = true;

  radioButtons;
  prospectsFe = AppFeatureExtensions.PROSPECT;
  selectedCandidateType = DIRECT_APPLICANTS;
  totalFilterSelected = 0;
  totalHMFilterSelected = 0;
  statusSelected: string[];
  isSelectDisabled = false;
  sidebarOpened = false;
  radioButtonSelected: string;
  currentRoute$ = this.store.select(getInnerRouterPath);
  constructor(
    private route: ActivatedRoute,
    private featureExtensionService: MojoFeatureExtensionsService,
    private store: Store,
  ) {}

  ngOnInit() {
    this.featureExtensionService.hasFeatureExtension(this.prospectsFe).subscribe((isProspect) => {
      if (isProspect) {
        this.radioButtons = [
          { value: 'prospects', label: PROSPECTS_LABEL },
          { value: DIRECT_APPLICANTS, label: 'Direct applicants' },
        ];
      } else {
        this.radioButtons = [{ value: DIRECT_APPLICANTS, label: 'Direct applicants' }];
      }
      const shortlistedFilters = this.route.snapshot.queryParams.shortlistedFilters;
      if (!!shortlistedFilters && shortlistedFilters.includes(PROSPECTS_LABEL)) {
        this.selectedCandidateType = this.radioButtons[0].value;
        this.isSelectDisabled = true;
      }
      if (!!shortlistedFilters) {
        this.statusesChange.emit({ hmStatus: [], statuses: shortlistedFilters });
      }
    });
  }

  statusesSelected(selectedStatuses: string[]) {
    this.normalStatusesOpcSelected = selectedStatuses;
    this.totalFilterSelected =
      selectedStatuses.length && selectedStatuses[0] !== 'All statuses' ? 1 : 0;
    this.statusSelected = selectedStatuses;
    this.statusesChange.emit({ hmStatus: this.hmStatusesOpcSelected, statuses: selectedStatuses });
  }

  hmStatusesSelected(selectedStatuses: string[]) {
    this.totalHMFilterSelected = selectedStatuses.length ? 1 : 0;
    this.hmStatusesOpcSelected = selectedStatuses;

    this.statusesChange.emit({
      hmStatus: selectedStatuses,
      statuses: this.normalStatusesOpcSelected,
    });
  }

  matTabChanged($event) {
    this.radioButtonSelected = $event.tab.ariaLabel;
    if (this.radioButtonSelected === this.radioButtons[0].label) {
      this.statusesChange.emit({ statuses: [PROSPECTS_LABEL], hmStatus: [] });
      this.isSelectDisabled = true;
    } else {
      this.statusesChange.emit({ hmStatus: [], statuses: [] });
      this.isSelectDisabled = false;
    }
  }

  close() {
    this.sidebarOpened = false;
  }

  open() {
    if (this.radioButtonSelected !== PROSPECTS_LABEL) this.sidebarOpened = true;
  }
  onClearFilters() {
    this.statusSelected = [ALL_SELECTED];
    this.statusesChange.emit({ hmStatus: [], statuses: [ALL_SELECTED] });
  }
}
